
export const WorkflowCategories = {
  Upcoming: "Upcoming",
  CheckedInGuests: "Checked-In Guests",
  CheckingOutToday: "Checking Out Today",
  OccupiedRooms: "Occupied Rooms",
  AvailableRooms: "Available Rooms",
} as const;

export const menuItems: string[] = [
  WorkflowCategories.Upcoming,
  WorkflowCategories.CheckedInGuests,
  WorkflowCategories.CheckingOutToday,
  WorkflowCategories.OccupiedRooms,
  WorkflowCategories.AvailableRooms,
];